<template>
  <v-dialog v-model="show" max-width="900px" title="testsets">
    <v-card>
      <v-card-title>
        <span class="headline">{{ tabValue ? '解除绑定' : '绑定应用' }}</span>
      </v-card-title>
      <v-tabs class="v-padding" v-model="tabValue">
        <v-tab key="base">绑定应用</v-tab>
        <v-tab key="detail">解绑应用</v-tab>
        <!-- v-tab key="extraConfig">安装配置</v-tab> -->
      </v-tabs>
      <div v-show="tabValue == 0">
        <v-item-group active-class="primary is-active" v-loading="loading" :value="selectedAppIndex" @change="change">
          <v-container>
            <v-row>
              <v-col v-for="(item, index) in data" :key="index" cols="3">
                <v-item v-slot="{ active, toggle }">
                  <v-card class="d-flex align-center" height="60px" @click="toggle"
                    style="padding: 0 1rem; box-shadow: none;border: 1px solid #f6f6f6;">
                    <v-avatar class="img" size="36">
                      <img :src="imgSrcTimestamp(item.masterImg)" :onerror="defaultAppIcon" />
                    </v-avatar>
                    <span style="margin-left: 1rem;">{{ item.appName }}</span>
                  </v-card>
                </v-item>
              </v-col>
            </v-row>
          </v-container>
          <div class="text-center" v-if="Math.round(pagination.total / pagination.itemsPerPage)">
            <v-pagination v-model="pagination.page" :length="Math.round(pagination.total / pagination.itemsPerPage)"
              :total-visible="5" />
          </div>
        </v-item-group>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="normal" @click="show = false" text>取消</v-btn>
          <v-btn color="error" @click="confirm" text>确定</v-btn>
        </v-card-actions>
      </div>
      <div v-if="tabValue == 1" style="padding: 12px">
        <Unbind :schemeData="item" @alert="val => $emit('alert', val)"/>
      </div>
    </v-card>
  </v-dialog>
</template>
<script>
import { buildAxios } from '@/plugins/axios'
// import { handleResponse } from '@/plugins/errorHandler'
import Unbind from './unbindTable.vue'
import { imgSrcTimestamp } from '@/plugins/utils'
export default {
  props: {
    modelvalue: {
      type: Boolean,
      default: false
    },
    item: {
      type: Object,
      default: null
    }
  },
  components: {
    Unbind
  },
  watch: {
    modelvalue (val) {
      this.show = val
    },
    show (val) {
      if (!val) {
        this.tabValue = 0
        this.selectedAppIndex = null
        this.$emit('close', false)
      } else {
        this.getAppList()
      }
    },
    pagination: {
      async handler (val) {
        await this.getAppList()
        this.selectedAppIndex = null
      },
      deep: true
    }
  },
  model: {
    prop: 'modelvalue',
    event: 'change'
  },
  data () {
    return {
      show: false,
      loading: false,
      pagination: { page: 1, itemsPerPage: 24, total: 0 },
      data: [],
      defaultAppIcon: 'this.src="' + require('@/assets/icon/example.svg') + '"',
      selectedAppIndex: null,
      tabValue: 0
    }
  },
  mounted () {

  },
  methods: {
    imgSrcTimestamp,
    async getAppList () {
      this.loading = true
      // this.pagination.page = 1
      const str = ''
      const request = buildAxios()
      await request.get('baseApp/page?page=' + (this.pagination.page - 1) + '&size=' + this.pagination.itemsPerPage + str + '&supportSchedule=1&platType=' + this.initPlatTyoe(this.item.platType))
        .then(res => {
          this.loading = false
          this.pagination.total = res.data.data.totalSize
          const data = res.data.data.data
          data.forEach(item => {
            if (item.extraConfig.img) {
              const masterImgObj = item.extraConfig.img.find(item => {
                return item.src !== ''
              })
              this.$set(item, 'masterImg', masterImgObj ? masterImgObj.src : '')
            }
          })
          this.data = data
        })
        .catch(reason => {
          //
          console.error(reason)
        })
    },
    toggle (val) {
      console.log('toggle')
    },
    change (val) {
      this.selectedAppIndex = val
    },
    async confirm () {
      const request = buildAxios()
      const params = {
        bindCode: this.data[this.selectedAppIndex].appCode,
        bindType: 'app',
        scheduleCode: this.item.code
      }
      await request.post('baseScheduleBindInfo/save', params).then(r => {
        this.$emit('alert', {
          msg: '方案绑定成功！',
          type: 'success'
        })
        this.show = false
      }).catch(err => {
        console.log(err)
      })
    },
    initPlatTyoe (type) {
      const typeArr = type.split(',') || []
      if (typeArr.lenght < 0) return undefined
      if (['app', 'h5', 'wxMiniProgram'].includes(typeArr[0])) return 'mobile'
      if (['pc'].includes(typeArr[0])) return 'pc'
      if (['selfService'].includes(typeArr[0])) return 'selfService'
      return undefined
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep .v-dialog {
  background-color: white !important;
}

.app-list {
  width: 100%;
  overflow-y: auto;
  display: flex;
  flex-wrap: wrap;

  .app-item {

    width: 3rem;
    height: 3rem;
    margin: 0.5rem;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: green;

    .img {
      img {
        width: 100%;
        height: 100%;
      }
    }
  }

}

.v-padding {
  padding: 0 12px;
}

.is-active {
  color: white !important;
}
</style>
